import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { errorHandling } from './errorHandling';

const LazyCarousels = React.lazy(() => import('Products/Carousels').catch(errorHandling));

const CarouselsLoader = () => (
    <ErrorBoundary fallback={<></>}>
        <Suspense fallback={<div></div>}>
            <LazyCarousels />
        </Suspense>
    </ErrorBoundary>
);

export default CarouselsLoader;
